import React, { useEffect } from "react"
import { i18n } from "next-i18next"
import { serverSideTranslations } from "next-i18next/serverSideTranslations"
import { useDispatch } from "react-redux"

import MyServices from "@/components/MyServices/v1/MyServices/MyServices"

import GlobalPageHeader from "@/components/Shared/GlobalPage/GlobalPageHeader"
import GlobalPageFooter from "@/components/Shared/GlobalPage/GlobalPageFooter"
import GlobalPageLayout from "@/components/Shared/GlobalPage/GlobalPageLayout"
import { footerUrl, headerUrl, MyServicePageDataUrl } from "@/constants"
import AemGrid from "@/components/AemGrid"
import { aemAxiosInstance } from "@/constants/api"
import { getClienIP, getDataLayerObj, filterBackEndJson } from "@/utils/helper"
import usePageAuth from "@/hooks/usePageAuth"
import {
  setDatalayerPageName,
  setGbhDataLayerCustom,
} from "@/store/features/genericSlice"
import MyGenericFiller from "@/components/MyGenericFiller"
import UpSellInstallServices from "@/components/Shared/UpsellInstallServices"

const MyServicePage = ({
  locale,
  tmpData: data,
  headertmp: header,
  footertmp: footer,
  ip,
  globalScript,
  footerScript,
  analysticsScript,
  analyticsData,
  datalayerPageName,
  gbhDataLayerCustom,
}) => {
  const dispatch = useDispatch()
  usePageAuth()
  useEffect(() => {
    getDataLayerObj(analyticsData)
  }, [analyticsData])

  useEffect(() => {
    dispatch(setDatalayerPageName(datalayerPageName))
    dispatch(setGbhDataLayerCustom(gbhDataLayerCustom))

    return () => {
      dispatch(setDatalayerPageName(""))
      dispatch(setGbhDataLayerCustom(""))
    }
  }, [])
  return (
    <GlobalPageLayout
      header={
        <GlobalPageHeader
          header={header}
          title={data.title}
          globalScripting={globalScript}
          analysticsScript={analysticsScript}
        />
      }
      footer={<GlobalPageFooter footer={footer} footerScripting={footerScript} />}
    >
      <AemGrid
        data={data}
        count={0}
        myServices={data => <MyServices data={data} />}
        myGenericFiller={data => (
          <MyGenericFiller data={data} title="myServices" />
        )}
        upSellContainer={data => <UpSellInstallServices authData={data} />}
      />
    </GlobalPageLayout>
  )
}

/**
 * Get ServerSideProps together.
 * @param {Object} request The first number.
 * @return {object} The props.
 */
export async function getServerSideProps({ req, locale }) {
  await i18n?.reloadResources()
  const urlPath = req.url.split("?")[0] ?? ""
  const ip = getClienIP(req)
  const { data } = await aemAxiosInstance({
    url: `/${locale}${MyServicePageDataUrl}`,
    method: "GET",
  })
  const { data: header } = await aemAxiosInstance({
    url: `${data.headerExpFrg ? data.headerExpFrg : headerUrl}.model.json`,
    method: "GET",
  })

  const { data: footer } = await aemAxiosInstance({
    url: `${data.footerExpFrg ? data.footerExpFrg : footerUrl}.model.json`,
    method: "GET",
  })
  const globalScript = data?.globalScript ? data.globalScript : null
  const footerScript = data?.footerScript ? data.footerScript : null
  const topHeadScript = data?.topHeadScript ? data?.topHeadScript : null
  const analyticsScriptClass = data?.analyticsScriptClass
    ? data?.analyticsScriptClass
    : null

  const gbhDataLayerCustom = {}
  if (data?.datalayerPageName) {
    gbhDataLayerCustom.datalayerPageName = data?.datalayerPageName
  }
  if (data?.eventPageType) {
    gbhDataLayerCustom.eventPageType = data?.eventPageType
  }
  if (data?.pageType) {
    gbhDataLayerCustom.pageType = data?.pageType
  }
  const analysticsScript = data?.adobeAnalytic || null
  let tmpData = {}
  if (data.pageComponentProperties) {
    tmpData = data.pageComponentProperties
  } else {
    tmpData = data
  }
  const analyticsData = data?.data
  const datalayerPageName = data?.datalayerPageName
  tmpData = filterBackEndJson(tmpData)
  const headertmp = filterBackEndJson(header)
  const footertmp = filterBackEndJson(footer)
  const metaContent = data?.metaContent ?? ""
  const canonicalUrl = data?.canonicalUrl ?? ""
  return {
    props: {
      ip,
      tmpData,
      headertmp,
      footertmp,
      globalScript,
      footerScript,
      topHeadScript,
      analysticsScript,
      analyticsScriptClass,
      analyticsData,
      datalayerPageName,
      gbhDataLayerCustom,
      urlPath,
      metaContent,
      canonicalUrl,
      ...(await serverSideTranslations(locale, ["common"])),
    },
  }
}

export default MyServicePage
